// extracted by mini-css-extract-plugin
module.exports = {"emoji":"Emoji-moduleemoji2pl"};